import axios from '../utilities/Axios';

export default {
  getTeachers: async (filters) => (await axios.get('/teachers', {params: filters})).data.data,
  getCount: async () => (await axios.get(`/teachers/count`)).data.data
}

